import React from 'react'
import { Link } from 'react-router'
import Navigation from '@App/navigation'

const MatchingHelperText = () => (
    <div className="no-results-text">
        <p>It looks like we couldn&apos;t locate any results for the search terms.</p>
        <p>Double-check your search terms or try searching again using other criteria.</p>
        <br />
        <p>If you&apos;re still having trouble finding the recording, it may be that:</p>
        <li>The MLC has not received any usage data from the DSPs for this recording.</li>
        <li>
            This recording has already been matched to the work. Try locating the work in the Public Search to see if it
            has already been matched.
        </li>{' '}
        <br />
        <p>
            If you still need help, <Link to={Navigation.contactUs.root()}>contact us</Link>.
        </p>
    </div>
)

export default MatchingHelperText
